import { FileText, Plus } from 'lucide-react'
import { useCreatePage } from '../hooks/useCreatePage'
import { Button } from '@/components/ui/button'

interface PagesEmptyStateProps {
  projectId: string
  projectKey: string
  workspaceSlug: string
  navigateToPage?: (slug: string) => void
}

export function PagesEmptyState({
  projectId,
  projectKey,
  workspaceSlug,
  navigateToPage,
}: PagesEmptyStateProps) {
  const handleCreatePage = useCreatePage({ projectId, projectKey, workspaceSlug, navigateToPage })

  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <FileText className="size-10 text-muted-foreground/50 mb-3" />
      <h3 className="text-sm font-medium mb-1">No pages yet</h3>
      <p className="text-sm text-muted-foreground mb-4">
        Create your first page to capture notes, specs, and docs for this project
      </p>
      <Button size="sm" onClick={() => { void handleCreatePage() }}>
        <Plus className="size-3.5 mr-1.5" />
        Create page
      </Button>
    </div>
  )
}
